import type { IssueSibling } from '~/api/help-center/types/Issue.types'
import type { Resolution } from '~/api/resolution-engine/types/GetResolution.types'

type FormatCustomerIssueParams =
  | IssueSibling[]
  | Resolution['problemContext']['problem']['issues']

export const formatCustomerIssue = (issueList: FormatCustomerIssueParams) => {
  return issueList.map((issue) => {
    if (issue.tag) {
      return `${issue.tag}-${issue.customerIssue}`
    }

    return issue.customerIssue
  })
}
